import { connect } from 'react-redux';
import CustomerComponent from '../../../components/orders-drawer/sections/customer';
import Global from '../../../store/global-selectors';
import { mapDispatchToOnClick, mapStateToOpen } from './section-container-helper';
import { OrderDrawerSection } from '../../../enums/order-drawer-section';

const sectionId = OrderDrawerSection.customer;

const mapStatesToProps = (state, ownProps) => {
  const { currentFulfillmentPlanId } = ownProps;
  const shipTo =
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId: currentFulfillmentPlanId,
      property: 'shipTo',
    }) || {};
  return {
    shipTo,
    ...mapStateToOpen(state, sectionId),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...mapDispatchToOnClick(dispatch, sectionId),
  };
};

export const CustomerSectionContainer = connect(mapStatesToProps, mapDispatchToProps);
export const Customer = CustomerSectionContainer(CustomerComponent);
